"use strict";

exports.__esModule = true;
exports.getTimelineColumns = getTimelineColumns;
exports.getTimelineDefinition = getTimelineDefinition;
exports.getTimelineDefinitions = getTimelineDefinitions;
exports.getTimelineFieldName = void 0;
exports.getTimelineName = getTimelineName;
exports.getTimelinesIdentifier = getTimelinesIdentifier;
var _Utils = require("../../../../Utils");
function getTimelineName(timelineType) {
  var nameArray = timelineType.split(/[_-]/);
  return (0, _Utils.capitalizeWords)(nameArray);
}
var getTimelineFieldName = exports.getTimelineFieldName = (0, _Utils.memoize)(function (field) {
  var nameArray = field.split(".");
  var name = nameArray[nameArray.length - 1];
  return (0, _Utils.capitalizeWords)(name.split(/[-_]/));
});
function getTimelinesIdentifier(timelineData) {
  return timelineData.type ? {
    name: getTimelineName(timelineData.type),
    value: timelineData.type
  } : {
    name: "",
    value: ""
  };
}
function getTimelineDefinition(timelineData) {
  var columns = timelineData.fields ? timelineData.fields.map(function (field) {
    return {
      id: field,
      name: getTimelineFieldName(field),
      sanitizedFieldName: getTimelineFieldName(field),
      type: "",
      enableSorting: false,
      canFilter: false,
      usePlantTime: true,
      showFilterIcon: false,
      showBarChart: false,
      barChartBackgroundColor: "#68ccca",
      barChartScaleSource: "auto",
      barChartMinValue: 0,
      barChartMaxValue: 100
    };
  }) : [];
  return {
    columns: columns,
    parseData: function parseData(responseData) {
      return responseData;
    },
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        columns: [],
        enablePagination: true,
        overFetchAll: true,
        defaultPageSize: "auto"
      };
    }
  };
}
function getTimelineColumns(timelineDefinitions, dataSource) {
  var hasTimelineDef = timelineDefinitions[dataSource];
  if (hasTimelineDef) {
    return timelineDefinitions[dataSource].columns;
  }
  return [];
}
function getTimelineDefinitions(apiData) {
  var timelineIdentifiers = apiData.map(getTimelinesIdentifier);
  var timelineDefinitions = {};
  apiData.forEach(function (timelineData) {
    var timelineValue = timelineData.type;
    timelineDefinitions[timelineValue] = getTimelineDefinition(timelineData);
  });
  return {
    timelineIdentifiers: timelineIdentifiers,
    timelineDefinitions: timelineDefinitions
  };
}